import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import modelsReducer from './models_reducer'
import casosReducer from './casos_reducer'
import userRecuder from './user_reducer'
import commentsReducer from './comments_reducer'
import auth from './auth_reducer'
import loadingReducer from './loading_reducer'
import appReducer from './app_reducer'
import notificationsReducer from './notifications_reducer'
import setpsReducer from './steps_reducer'


export default function rootReducer(asyncReducers){
    return combineReducers({
        auth,
        form,
        caso: modelsReducer,
        casos: casosReducer,
        user: userRecuder,
        comments: commentsReducer,
        loading: loadingReducer,
        activeSection: appReducer,
        notifications: notificationsReducer,
        steps: setpsReducer,
        ...asyncReducers
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/index.js